import React from 'react';
import FormContainer from '../components/common/FormContainer';
import SignupForm from '../components/forms/SignupForm';

const Signup = () => {
    return (
        <FormContainer>
            <SignupForm />
        </FormContainer>
    );
};

export default Signup;
